<div class="modal-header" appCustomAutofocus>
    <h3>Initialize Attachment</h3>
</div>
<div class="modal-body">
    <div role="alert" Class="alert alert-info">This will attach all documents to the rehired employee's employee record.  A new HR resource will NOT be created.  Continue?</div>
</div>
<div class="modal-footer">
    <button class="btn btn-primary" type="button" (click)="confirmClicked()">Confirm</button>
    <button class="btn btn-outline-dark" type="button" (click)="cancelClicked()">Cancel</button>
</div>